import { FacilityIpConfiguration, FacilityMbConfiguration } from "../index";
import { Group } from "./group";
import { FacilityConfiguration } from "./index";
import { FacilityThreshold } from "./facility-threshold";

export class CorporateLocation {
    corporateLocationId: string;
    corporateLocationName: string;
    corporateId: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    pccOrgId: string;
    pccOrgUuid: string;
}


export class Facility {
    id: string;
    facilityName: string;
    email: string;
    website: string;
    isActive: boolean;
    isDeleted: boolean;
    createdOn: Date;
    updatedOn: Date;
    createdBy: string;
    updateBy: string;
    timeZone: string;
    dst: string;
    isMultiuser: boolean;
    description: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    location: CorporateLocation;
    configuration: FacilityConfiguration;
    ipConfigurations: FacilityIpConfiguration[];
    mbConfiguration: FacilityMbConfiguration;
    facilityThresholds: FacilityThreshold[];
    groups: Group[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/facility.ts